import {DELETE_MAGAZINE_START} from "../../types";

export const delete_magazine = (payload) => ({
    type: DELETE_MAGAZINE_START,
    payload,
});
